export const PLACEHOLDER_PASSWORD = 'i_am_a_secure_password';
